import React from "react";
import Imagen from "../images/imagen.jpg";
const Acerca = () => {
  return ( 
    <div
      id="acerca"
      className="lg:h-screen h-full justify-center flex items-center w-full bg-slate-800"
    >
      <div className="xl:w-8/12   lg:w-10/12   m-auto">
        <div className="flex">
          <div className="flex w-full justify-center flex items-center text-gray-300">
            <h4 className="text-emerald-300 sm:text-xl text-lg md:text-2xl mt-0.5">
              01.
            </h4>
            <h4 className="text-gray-300   font-bold ml-3 text-xl sm:text-2xl md:text-3xl">
              About me
            </h4>
            <div className="mr-12"></div>
            <div className="border w-4/12 flex sm:w-6/12 md:w-8/12 h-0 "></div>
          </div>
        </div>
        <div className="sm:flex">
          <div className="text-gray-400   sm:w-7/12 mr-8 mt-6">
            <h4 className="mt-2">
            Hello! My name is Yeremi and I enjoy programming since
              <a
                target="_blank"
                href="https://github.com/Yeremi528"
                className="text-emerald-300  ml-2"
              >
                websites to mobile applications.
              </a>{" "}
              My interest in development began at a very young age, passing me
               fixing computers of acquaintances until solving problems
               with kali and linux applications, where I started to develop my
               first steps as a developer so far where I focus on
               building FullStack solutions and applications.
            </h4>
            <div className="sm:flex hidden">
              <div>
                <h4 className="mt-4  text-lg text-gray-300 font-semibold hover:underline">
                Where do I develop my knowledge?
                </h4>
                <h4 className="mt-2">
                I started looking at content{" "}
                  <a
                    className="text-emerald-300 ml-1 mr-1"
                    href="https://ocw.mit.edu/"
                    target="_blank"
                  >
                    MIT(Massachusetts Institute of Technology)
                  </a>
                  that you have available on your OpenCourse page. I decided to start
                   learn programming with courses by {" "}
                  <a
                    target="_blank"
                    className="text-emerald-300"
                    href="https://www.edx.org/es"
                  >
                    EDX
                  </a>
                  , YouTube videos, books, and courses by {" "}
                  <a
                    className="text-emerald-300"
                    target="_blank"
                    href="https://www.udemy.com/"
                  >
                    Udemy
                  </a>
                  .{" "}
                </h4>
                <h4 className="mt-4  text-lg font-semibold hover:underline text-gray-300">
                What inspired me
                </h4>
                <h4 className="mt-2">
                My main inspiration to start on the path of
                   self-taught was a book of {" "}
                  <a
                    target="_blank"
                    className="text-emerald-300 mr-1"
                    href="https://www.scotthyoung.com/"
                  >
                    Scott H.Young
                  </a>
                  with his ultralearning book in which he talks about methods and
                   techniques to acquire knowledge at a very fast speed
                   elevated.
                </h4>
              </div>
            </div>
          </div>
          <div className="w-6/12 justify-center m-auto items-center  sm:w-5/12">
            <img
              src={Imagen}
              alt="Yo"
              className=" grayscale  hover:grayscale-0 delay-150  duration-300 motion-safe:hover:scale-110 rounded-3xl mt-8 h-auto"
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Acerca;
